import React, { createContext, useContext, useState, useCallback, useRef } from 'react';

interface CoinCelebrationContextType {
  triggerCelebration: () => void;
  isVisible: boolean;
  hideCelebration: () => void;
}

const CoinCelebrationContext = createContext<CoinCelebrationContextType | null>(null);

export function useCoinCelebration() {
  const context = useContext(CoinCelebrationContext);
  if (!context) {
    throw new Error('useCoinCelebration must be used within CoinCelebrationProvider');
  }
  return context;
}

interface CoinCelebrationProviderProps {
  children: React.ReactNode;
}

export function CoinCelebrationProvider({ children }: CoinCelebrationProviderProps) {
  const [isVisible, setIsVisible] = useState(false);
  const hideTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const triggerCelebration = useCallback(() => {
    console.log('🎉 [CoinCelebration] Triggering celebration!');

    if (hideTimeoutRef.current) {
      clearTimeout(hideTimeoutRef.current);
    }

    setIsVisible(true);

    hideTimeoutRef.current = setTimeout(() => {
      setIsVisible(false);
    }, 3000);
  }, []);

  const hideCelebration = useCallback(() => {
    if (hideTimeoutRef.current) {
      clearTimeout(hideTimeoutRef.current);
    }
    setIsVisible(false);
  }, []);

  return (
    <CoinCelebrationContext.Provider value={{ triggerCelebration, isVisible, hideCelebration }}>
      {children}
    </CoinCelebrationContext.Provider>
  );
}
